
import { sidebarReducer } from './SideBar';
import { authReducer } from './Auth';
import { rintagiReducer } from './_Rintagi';
import { notificationReducer } from './Notification';
import { globalReducer } from './Global';
import { SqlReportReducer } from './SqlReport';
import { CustomReducer } from './Custom';

/* below are dynamic, put shared static one above this */
import RBtnTrackingReduxObj from './RBtnTracking';
import VwRUsrButtonTrackingReduxObj from './VwRUsrButtonTracking';
import RSignUpSurveyReduxObj from './RSignUpSurvey';
import VwRUsrSignUpSurveyReduxObj from './VwRUsrSignUpSurvey';
import SubTestReduxObj from './SubTest';
import VwRUsrSubDtlReduxObj from './VwRUsrSubDtl';
export default {
    auth: authReducer,
    rintagi: rintagiReducer,
    global: globalReducer,
    sidebar: sidebarReducer,
    notification: notificationReducer,
    SqlReport: SqlReportReducer,
    ...(CustomReducer || {}),
    /* dynamic go to here */
    RBtnTracking: RBtnTrackingReduxObj.ReduxReducer(),
    VwRUsrButtonTracking: VwRUsrButtonTrackingReduxObj.ReduxReducer(),
    RSignUpSurvey: RSignUpSurveyReduxObj.ReduxReducer(),
    VwRUsrSignUpSurvey: VwRUsrSignUpSurveyReduxObj.ReduxReducer(),
    SubTest: SubTestReduxObj.ReduxReducer(),
    VwRUsrSubDtl: VwRUsrSubDtlReduxObj.ReduxReducer(),
}



// WEBPACK FOOTER //
// ./src/redux/index.js